import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/NewFooter';
import AnalyticsTracker from './components/AnalyticsTracker';
import Home from './pages/Home';
import About from './pages/About';
import NewAboutSection from './pages/NewAboutSection';
import GalleryPage from './pages/GalleryPage';
import Services from './pages/ServicesPage';
import Projects from './pages/ProjectsPage';
import Contact from './pages/Contact';
import BlogIndex from './pages/blog/BlogIndex';
import Blog1ElectriciansQatar from './pages/blog/Blog1-ElectriciansQatar';
import Blog2PlumbersQatar from './pages/blog/Blog2-PlumbersQatar';
import Blog3MasonsQatar from './pages/blog/Blog3-MasonsQatar';
import Blog4WeldersQatar from './pages/blog/Blog4-WeldersQatar';
import Blog5HVACQatar from './pages/blog/Blog5-HVACQatar';
import Blog6PaintersQatar from './pages/blog/Blog6-PaintersQatar';
import Blog7WaterproofingQatar from './pages/blog/Blog7-WaterproofingQatar';
import Blog8SafetyManpowerQatar from './pages/blog/Blog8-SafetyManpowerQatar';
import CivilSubcontracting from './pages/services/CivilSubcontracting';
import MepContracting from './pages/services/MepContracting';
import FitOutWorks from './pages/services/FitOutWorks';
import ManpowerSupply from './pages/services/ManpowerSupply';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <AnalyticsTracker />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<NewAboutSection />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/civil-subcontracting" element={<CivilSubcontracting />} />
              <Route path="/services/mep-contracting" element={<MepContracting />} />
              <Route path="/services/fit-out-works" element={<FitOutWorks />} />
              <Route path="/services/manpower-supply" element={<ManpowerSupply />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<Contact />} />
              {/* Blog Routes */}
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/electricians-qatar" element={<Blog1ElectriciansQatar />} />
              <Route path="/blog/plumbers-qatar" element={<Blog2PlumbersQatar />} />
              <Route path="/blog/masons-laborers-qatar" element={<Blog3MasonsQatar />} />
              <Route path="/blog/welders-qatar" element={<Blog4WeldersQatar />} />
              <Route path="/blog/hvac-specialists-qatar" element={<Blog5HVACQatar />} />
              <Route path="/blog/painters-qatar" element={<Blog6PaintersQatar />} />
              <Route path="/blog/waterproofing-epoxy-qatar" element={<Blog7WaterproofingQatar />} />
              <Route path="/blog/iso-safety-manpower-qatar" element={<Blog8SafetyManpowerQatar />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 